// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cell":"table-cell__cell--2nD4F","head":"table-cell__head--1fad8"};